import React, { useEffect, useRef, useState } from "react";
import { getStatusColor } from "../../HotelPage/utils/hotelUtils";

const FEATURE_STATUS_COLOR_MAP = {
  LIVE: "Good",
  PAS_EQUIPE: "À équiper",
  DESEQUIPE: "Warning",
  OFF: "Failed",
  __NONE__: "N/A",
};

const getFeatureFilterStatusColor = (statusValue) =>
  getStatusColor(FEATURE_STATUS_COLOR_MAP[statusValue] || statusValue);

const FeatureStatusFilter = ({
  availableStatuses,
  selectedStatuses,
  onStatusToggle,
  onSelectAll,
  onClearAll,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (disabled || !availableStatuses.length) {
    return null;
  }

  const allSelected = selectedStatuses.length === availableStatuses.length;
  const hasActiveFilters = !allSelected;

  return (
    <div className="relative" ref={containerRef}>
      <button
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#365644] hover:text-[#2b4234]"
      >
        <span>Statut</span>
        {hasActiveFilters && <span className="w-2 h-2 rounded-full bg-blue-500" />}
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.121A1 1 0 013 6.414V4z"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute z-50 top-full left-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg min-w-64 max-h-72 overflow-y-auto">
          <div className="px-3 py-2 border-b border-gray-100 bg-gray-50 rounded-t-lg flex items-center justify-between gap-2">
            <span className="text-sm font-medium text-gray-700">Filtrer par statut</span>
            <div className="flex gap-2 text-[10px] font-semibold uppercase tracking-wide">
              <button type="button" onClick={onSelectAll} className="text-[#365644] hover:underline">
                Tous
              </button>
              <button type="button" onClick={onClearAll} className="text-gray-500 hover:underline">
                Aucun
              </button>
            </div>
          </div>

          <div className="py-1">
            {availableStatuses.map((status) => {
              const isSelected = selectedStatuses.includes(status.value);
              return (
                <button
                  key={status.value}
                  type="button"
                  onClick={() => onStatusToggle(status.value)}
                  className="w-full flex items-center px-3 py-2 hover:bg-gray-50 text-left"
                >
                  <div
                    className={`w-4 h-4 mr-3 border-2 rounded flex items-center justify-center shrink-0 ${
                      isSelected ? "bg-blue-600 border-blue-600" : "border-gray-300"
                    }`}
                  >
                    {isSelected && (
                      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                  </div>
                  <div className={`w-3 h-3 rounded-full mr-2 shrink-0 ${getFeatureFilterStatusColor(status.value)}`} />
                  <span className="text-sm text-gray-700 flex-1">{status.label}</span>
                  <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">{status.count}</span>
                </button>
              );
            })}
          </div>

          <div className="px-3 py-2 border-t border-gray-100 bg-gray-50 rounded-b-lg">
            <span className="text-xs text-gray-500">
              {selectedStatuses.length} sur {availableStatuses.length} statuts sélectionnés
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeatureStatusFilter;
